import React from 'react';

import {
  Button,
  PrimaryButton,
  ToolTip,
  Icon,
  useTranslation,
} from '@testsigma/atoms';

import { SalesforceLoginMethod } from '@modules/salesforce/models';

interface UserNameAndPasswordFormActionProps {
  loginMethod: SalesforceLoginMethod;
  isConnecting: boolean;
  isValid: boolean;
  isTestConnecting: boolean;
  handleLogin: () => void;
  handleUpdate?: () => void;
  handleClose: (event: React.SyntheticEvent) => void;
}

const UserNameAndPasswordFormAction: React.FC<
  UserNameAndPasswordFormActionProps
> = (props: UserNameAndPasswordFormActionProps) => {
  const { t } = useTranslation();

  const {
    loginMethod,
    isConnecting,
    isValid,
    isTestConnecting,
    handleLogin,
    handleUpdate,
    handleClose,
  } = props;

  if (loginMethod !== SalesforceLoginMethod.USERNAME_PASSWORD) {
    return;
  }

  return (
    <div className='px-4 py-3 text-right'>
      <Button type='secondary' isDisabled={isConnecting || isTestConnecting} onClick={handleClose}>
        {t('common.cancel')}
      </Button>
      <ToolTip content={!isValid ? t('connection.mandatory_fields') : ''}>
        {handleUpdate ? (
          <PrimaryButton
            className='ml-4'
            isDisabled={!isValid || isConnecting || isTestConnecting}
            onClick={handleUpdate}>
            {t('common.save.changes')}
          </PrimaryButton>
        ) : (
          <PrimaryButton
            className='ml-4'
            isDisabled={!isValid || isConnecting || isTestConnecting}
            onClick={handleLogin}>
            <>
              {isConnecting ? (
                <div className='flex gap-x-1.5 items-center'>
                  <Icon className='text-base flex animate-spin' name='loader' />
                  {t('connecting.button.label')}
                </div>
              ) : (
                t('connect.button.label')
              )}
            </>
          </PrimaryButton>
        )}
      </ToolTip>
    </div>
  );
};

export { UserNameAndPasswordFormAction };
